o2-icon {
  display: inline-block;
  vertical-align: top;
  min-width: 1.25em;
  height: 1.25em;
}

o2-icon > svg {
  display: block;
  width: auto;
}

:host-context(h1),
:host-context(h2),
:host-context(h3),
:host-context(h4),
:host-context(h5),
:host-context(h6) {
  margin-right: 0.15em;
}

.o2-icon {
  transition: all 0.3s var(--o2-transition);
}

// generate Design System colors
@include o2-generate-color('o2-icon');

.o2-icon__container {
  display: flex;
  width: 100%;
  height: 100%;
}

:host-context(.tooltip-icon-wrapper) {
  font-size: 24px;
  height: 48px;
  margin-right: 15px;
}
